<template>
  <div>
    <h4 class="header">Assinatura</h4>
    <div class="buttons">
      <b-button
        type="button"
        size="sm"
        @click.prevent="undo"
        class="mb-2 mr-2 btn-undo"
      >
        Refazer
      </b-button>
      <b-button
        type="button"
        size="sm"
        @click.prevent="save"
        class="mb-2 btn-save"
      >
        Finalizar
      </b-button>
      <!-- <button @click.prevent="undo">Refazer assinatura</button> -->
      <!-- <button @click.prevent="save">Finalizar assinatura</button> -->
    </div>
    <div class="sig-container">
      <vueSignature
        v-if="visivel"
        ref="signature"
        :sigOption="option"
        :disabled="disabled"
      ></vueSignature>
    </div>
  </div>
</template>

<script>
// Referencia
// https://github.com/WangShayne/vue-signature
import vueSignature from "vue-signature";
export default {
  name: "MySignaturePad",
  components: {
    vueSignature,
  },
  data: function () {
    return {
      visivel: false,
      option: {
        penColor: "rgb(0, 0, 0)",
        backgroundColor: "rgb(255,255,255)",
      },
      disabled: false,
    };
  },
  methods: {
    updateImageSrc(dataUrl) {
      // toDataURL
      if (dataUrl) {
        let _this = this;
        var img = document.createElement("img");
        img.src = dataUrl;

        img.onload = function () {
          var canvas = document.createElement("canvas");
          var ctx = canvas.getContext("2d");
          ctx.drawImage(img, 0, 0);

          var MAX_WIDTH = 1080;
          var MAX_HEIGHT = 1080;
          var width = img.width;
          var height = img.height;

          if (width > height) {
            if (width > MAX_WIDTH) {
              height *= MAX_WIDTH / width;
              width = MAX_WIDTH;
            }
          } else {
            if (height > MAX_HEIGHT) {
              width *= MAX_HEIGHT / height;
              height = MAX_HEIGHT;
            }
          }
          canvas.width = width;
          canvas.height = height;
          var ctx = canvas.getContext("2d");
          ctx.drawImage(img, 0, 0, width, height);

          _this.draftImageSrc = canvas.toDataURL("image/jpeg", 0.2);
          if (_this.originObject) {
            _this.$emit(
              "update-image-src",
              _this.originObject,
              _this.draftImageSrc
            );
          } else {
            _this.$emit("update-image-src", _this.draftImageSrc);
          }
        }; // img.onload
      }
    },
    undo() {
      var _this = this;
      _this.$refs.signature.clear();
    },
    save() {
      var _this = this;
      var jpeg = _this.$refs.signature.save("image/jpeg");
      this.updateImageSrc(jpeg);
    },
    hide() {
      this.visivel = false;
    },
    show() {
      this.visivel = true;
    },
  },
};
</script>
<style  scoped>
.sig-container {
  width: 100%;
  height: calc(100vh - 90px);
}
.header {
  margin-top: -10%;
  position: absolute;
  color: black;
  left: 38%;
  right: 0%;
}
.buttons{
  text-align: center;
}
.btn-undo {
  width: 125px;
}
.btn-save {
  width: 125px;
}
@media (max-width: 768px) {
  .buttons{
  padding-left: 0%;
}
  .btn-undo {
    width: 48%;
  }
  .btn-save {
    width: 48%;
  }
}
/* .sig-canvas {
  width: 100%;
  height: 100%;
  background-color: rgba(255,255,255, 0.9);
} */
</style>